// src/pages/Projects.jsx
import React from 'react';
import projectsBg from '../assets/images/companyImg.JPG'; // Import your background image for projects
import Urban from '../assets/images/Urban Road Rehabilitation.jpg';
import Fence from '../assets/images/fence.jpg';
import Land from '../assets/images/Landscaping.jpg';
import Renovation from '../assets/images/Public Facility Renovation.jpg';

function Projects() {
    return (
      // Outermost div: Acts as the container for the entire page and its background
      <div className="position-relative overflow-hidden">
        {/* Background Image Layer: Positioned absolutely to cover the entire outermost div */}
        <div
          className="position-absolute top-0 start-0 w-100 h-100"
          style={{
            backgroundImage: `url(${projectsBg})`, // Use the imported background image
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundAttachment: 'fixed', // Makes the background image static (parallax effect)
            opacity: 0.3, // Adjusted opacity for better readability of text
            zIndex: 0, // Ensures it's behind the content
          }}
        ></div>

        {/* Main Content Wrapper: All visible page content goes here, positioned above the background */}
        <div className="container py-2 position-relative z-1 text-dark"> {/* Added position-relative and z-1 */}
          <h1 className="mb-4 text-center display-4 fw-bold ">Our Projects</h1>
          <p className="lead text-center mb-5">
            At LIYO & SONS GROUP (PTY) Ltd, we take pride in the successful completion of diverse projects across civil engineering,
            property development, fencing, renovations, and more. Below are highlights of some of our work and capabilities.
          </p>

          {/* Projects Grid Section */}
          <section className="py-2 mb-5 position-relative z-1">
            <h3 className="mb-4 text-center">Featured Projects</h3>
            <div className="row justify-content-center">
              <div className="col-lg-10">
                <div className="row row-cols-1 row-cols-md-2 g-4">
                  <div className="col">
                    {/* Added custom class 'project-card' */}
                    <div className="card h-100 shadow-l= border-0 project-card">
                      <img
                            src={Urban}
                            className="card-img-top rounded-top project-card-img" // Added custom class 'project-card-img'
                            alt="Urban Road Rehabilitation"
                            // Inline style to ensure consistent image height and fit
                            style={{ height: '220px', objectFit: 'cover' }}
                          />
                      <div className="card-body text-center">
                        <h5 className="card-title">Urban Road Rehabilitation</h5>
                        <p className="card-text">
                          Road surfacing and stormwater infrastructure upgrade in a rural township, improving traffic flow and drainage.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="col">
                    {/* Added custom class 'project-card' */}
                    <div className="card h-100 shadow-lg border-0 project-card">
                      <img
                            src={Renovation}
                            className="card-img-top rounded-top project-card-img" // Added custom class 'project-card-img'
                            alt="Public Facility Renovation"
                            // Inline style to ensure consistent image height and fit
                            style={{ height: '220px', objectFit: 'cover' }}
                          />
                      <div className="card-body text-center">
                        <h5 className="card-title">Public Facility Renovation</h5>
                        <p className="card-text">
                          Complete upgrade of a municipal facility, including plumbing, tiling, and structural reinforcement.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="col">
                    {/* Added custom class 'project-card' */}
                    <div className="card h-100 shadow-lg border-0 project-card">
                      <img
                            src={Fence}
                            className="card-img-top rounded-top project-card-img" // Added custom class 'project-card-img'
                            alt="Security Fencing Installation"
                            // Inline style to ensure consistent image height and fit
                            style={{ height: '220px', objectFit: 'cover' }}
                          />
                      <div className="card-body text-center">
                        <h5 className="card-title">Security Fencing Installation</h5>
                        <p className="card-text">
                          High-performance fencing and perimeter security systems for industrial and residential properties.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="col">
                    {/* Added custom class 'project-card' */}
                    <div className="card h-100 shadow-lg border-0 project-card">
                      <img
                            src={Land}
                            className="card-img-top rounded-top project-card-img" // Added custom class 'project-card-img'
                            alt="Landscaping & Site Beautification"
                            // Inline style to ensure consistent image height and fit
                            style={{ height: '220px', objectFit: 'cover' }}
                          />
                      <div className="card-body text-center">
                        <h5 className="card-title">Landscaping & Site Beautification</h5>
                        <p className="card-text">
                          Design and implementation of aesthetically pleasing and sustainable landscapes for public and private clients.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>

          {/* Call to Action for More Projects (Optional) */}
          <div className="text-center m-5">
            <a href="/contact" className="btn btn-outline-warning btn-lg">View More Projects</a>
          </div>

        </div> {/* End of main content wrapper */}
      </div> // End of outermost div
    );
  }

  export default Projects;